import support from '../utils/BrowserSupport'

export const defaults = {
    position: null,
    data: {},
    renderElement: (data, self) => {
        const { componentClassName } = self.options;

        const element = document.createElement('div');
        element.className = componentClassName;

        const wrapper = document.createElement('div');
        wrapper.className = `${componentClassName}-wrapper`;
        wrapper.setAttribute('data-ref', 'wrapper');
        element.appendChild(wrapper);

        const content = document.createElement('div');
        content.className = `${componentClassName}-content`;
        content.setAttribute('data-ref', 'content');
        content.innerHTML = self.options.content;
        wrapper.appendChild(content);

        const arrow = document.createElement('div')
        arrow.className = `${componentClassName}-arrow`
        arrow.setAttribute('data-ref', 'arrow')
        wrapper.appendChild(arrow)

        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = `${componentClassName}-close`;
        closeButton.innerHTML = 'x';
        closeButton.addEventListener('click', self.close.bind(self));
        wrapper.appendChild(closeButton);

        return element;
    },
    componentClassName: 'InfoBox',
    content: 'content'
}

export const STATUS = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active'
};

export default class InfoWindow {

    constructor(options) {
        this.element = null

        this.options = {
            ...defaults,
            ...options
        }

        this.create()

        this.element.addEventListener(support.transitionEnd, event => {
            if (!this.element.classList.contains(STATUS.ACTIVE)) {
                this.element.classList.remove(STATUS.VISIBLE)
            }
        })
    }

    create() {
        this.element = this.options.renderElement(this.options.data, this)
        this.content = this.element.querySelector('[data-ref="content"]')
        this.wrapper = this.element.querySelector('[data-ref="wrapper"]')
        this.arrow = this.element.querySelector('[data-ref="arrow"]')
    }

    open(position, content) {
        let wrapperBox = this.wrapper.getBoundingClientRect()
        const parentBox = this.element.parentNode.getBoundingClientRect()

        if (!this.element.classList.contains(STATUS.VISIBLE)) {
            this.element.classList.add(STATUS.VISIBLE)
            wrapperBox = this.wrapper.getBoundingClientRect()
            this.element.classList.remove(STATUS.VISIBLE)
        }

        // left offset
        const left = Math.min(parentBox.left + position.x - wrapperBox.width / 2, 0)
        const right = Math.max(parentBox.left + position.x + wrapperBox.width / 2 - (document.body.clientWidth - 20), 0)
        const arrowLeft = position.x - left - right

        this.element.style.top = `${position.y}px`
        this.element.style.left = `${position.x - left - right}px`
        this.arrow.style.left = `${wrapperBox.width / 2 - (arrowLeft - position.x) - 5}px`

        this.content.innerHTML = content

        if (!this.element.classList.contains(STATUS.ACTIVE)) {
            this.element.classList.add(STATUS.VISIBLE)
            this.element.offsetWidth
            this.element.classList.add(STATUS.ACTIVE)
        }
    }

    close() {
        this.element.classList.remove(STATUS.ACTIVE)
    }

}